import React, { useState, useEffect, useContext, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Redirect } from "react-router-dom";
import dateFormat from "dateformat";
import { updateProject } from "../../graphql/mutations";
import { Input, notification, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Context } from "../../Store.js";
import { API, graphqlOperation } from "aws-amplify";
import "./style.css";

const ProjectDetailPage = () => {
  const [state, dispatch] = useContext(Context);
  //   const [projects, setProjects] = useState([]);
  const [project, setProject] = useState({
    id: "",
    projectName: "",
    identificationNumber: "",
    startDate: new Date(),
    endDate: new Date(),
    projectType: "",
    abstract: "",
    uploadAbstract: "",
    status: "",
    username: "",
  });

  const [redirect, setRedirect] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setProject({
      id: state.selectedProject.id,
      projectName: state.selectedProject.projectName,
      identificationNumber: state.selectedProject.identificationNumber,
      startDate: state.selectedProject.startDate,
      endDate: state.selectedProject.endDate,
      projectType: state.selectedProject.projectType,
      abstract: state.selectedProject.abstract,
      uploadAbstract: state.selectedProject.uploadAbstract,
      status: state.selectedProject.status,
      username: state.selectedProject.username,
    });
  }, []);

  const update = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    project.status = "ACTIVE";
    setProject({ ...project, status: "ACTIVE" });

    try {
      const projectData = await API.graphql(
        graphqlOperation(updateProject, {
          input: { ...project },
        })
      );
      notification.success({
        message: "Project Activated!",
        description: "Project Successfully Activated",
        placement: "topRight",
        duration: 2.0,
        onClose: () => {
          setProject({
            projectName: "",
            identificationNumber: "",
            startDate: new Date(),
            endDate: new Date(),
            projectType: "",
            abstract: "",
            uploadAbstract: "",
          });
          setIsLoading(false);
          setRedirect(`/new-project`);
        },
      });
    } catch (error) {
      notification.error({
        message: "Error updating project!",
        description: error.message,
        placement: "topRight",
        duration: 10.0,
        onClose: () => {
          setRedirect(null);
          setIsLoading(false);
        },
      });
    }
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  } else {
    return (
      <React.Fragment>
        <div
          className="container inner-class-container"
          style={{ height: "100%" }}
        >
          <form>
            <fieldset>
              <legend>Project Form</legend>
              <div className="form-group">
                <label htmlFor="projectName">Project Name</label>
                <input
                  className="form-control"
                  id="projectName"
                  aria-describedby="emailHelp"
                  disabled
                  value={project.projectName}
                />
              </div>

              <div className="form-group">
                <label htmlFor="identificationNumber">
                  Identification Number
                </label>
                <input
                  className="form-control"
                  id="identificationNumber"
                  disabled
                  value={project.identificationNumber}
                />
              </div>

              <div className="form-group">
                <label htmlFor="startDate">Project Start Date</label>
                <input
                  className="form-control"
                  disabled
                  value={dateFormat(project.startDate, "mmmm dS, yyyy")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="endDate">Project End Date</label>
                <Input
                  className="form-control"
                  disabled
                  value={dateFormat(project.endDate, "mmmm dS, yyyy")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="projectType">Project Type</label>
                <input
                  className="form-control"
                  id="projectType"
                  value={project.projectType}
                  disabled
                />
              </div>
              <div className="form-group">
                <a href={project.uploadAbstract} target="_blank">
                  View Abstract
                </a>
              </div>
              <a type="submit" className="btn btn-primary" onClick={update}>
                {isLoading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ fontSize: 24 }} />}
                  />
                ) : (
                  "Activate"
                )}
              </a>
            </fieldset>
          </form>
          <br />
        </div>
      </React.Fragment>
    );
  }
};

export default ProjectDetailPage;
